import * as React from "react";

import { useMyBagPresentationModel } from "../providers";

export const FixMagentoPaymentSection: React.FunctionComponent = () => {
  const { presentationMyBagOrder } = useMyBagPresentationModel();

  const handleAddElement_makeSureAnyBillingAddressPopulationsAreInACorrectStateGivenAVirtualOrder =
    React.useCallback((element: HTMLElement) => {
      if (element.classList.contains("checkout-billing-address")) {
        const element_billingAddress_sameAsShipping_inputCheckbox =
          element.querySelector(
            ".billing-address-same-as-shipping-block > input[type=checkbox]"
          );
        if (
          element_billingAddress_sameAsShipping_inputCheckbox instanceof
          HTMLInputElement
        ) {
          if (element_billingAddress_sameAsShipping_inputCheckbox.checked) {
            element_billingAddress_sameAsShipping_inputCheckbox.click();
          }
        }
      }
    }, []);

  const handleMakeSureAnyBillingAddressPopulationsAreInACorrectStateGivenAVirtualOrder_currentStateOfTheDocument =
    React.useCallback(() => {
      if (!presentationMyBagOrder) {
        return;
      }

      const targetNode = document.getElementById("checkout");
      if (!targetNode) {
        return;
      }
      const checkoutBillingAddressElements = targetNode.querySelectorAll(
        ".checkout-billing-address"
      );

      if (presentationMyBagOrder.isThisAVirtualOrder) {
        checkoutBillingAddressElements.forEach((element) => {
          if (element instanceof HTMLElement) {
            handleAddElement_makeSureAnyBillingAddressPopulationsAreInACorrectStateGivenAVirtualOrder(
              element
            );
          }
        });
      }
    }, [
      presentationMyBagOrder,
      handleAddElement_makeSureAnyBillingAddressPopulationsAreInACorrectStateGivenAVirtualOrder,
    ]);

  React.useEffect(() => {
    handleMakeSureAnyBillingAddressPopulationsAreInACorrectStateGivenAVirtualOrder_currentStateOfTheDocument();
    if (presentationMyBagOrder?.isThisAVirtualOrder) {
      try {
        document.body.classList.add(
          "payment-method-billing-address--needs-to-show-now"
        );
      } catch (anyError) {
        console.error(anyError);
      }
    } else {
      try {
        document.body.classList.remove(
          "payment-method-billing-address--needs-to-show-now"
        );
      } catch (anyError) {
        console.error(anyError);
      }
    }
  }, [
    handleMakeSureAnyBillingAddressPopulationsAreInACorrectStateGivenAVirtualOrder_currentStateOfTheDocument,
    presentationMyBagOrder,
  ]);

  React.useEffect(() => {
    if (!presentationMyBagOrder?.isThisAVirtualOrder) {
      return;
    }

    const targetNode = document.getElementById("checkout");
    if (!targetNode) {
      return;
    }

    const observer = new MutationObserver((mutationList, observer) => {
      mutationList.forEach((mutation) => {
        switch (mutation.type) {
          case "childList":
            mutation.addedNodes.forEach((node) => {
              if (node instanceof HTMLElement) {
                handleAddElement_makeSureAnyBillingAddressPopulationsAreInACorrectStateGivenAVirtualOrder(
                  node
                );
              }
            });
            break;
          default:
            break;
        }
      });
    });
    const config: MutationObserverInit = {
      childList: true,
      subtree: true,
    };
    observer.observe(targetNode, config);

    return () => {
      observer.disconnect();
    };
  }, [
    presentationMyBagOrder,
    handleAddElement_makeSureAnyBillingAddressPopulationsAreInACorrectStateGivenAVirtualOrder,
  ]);

  return null;
};
